import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'
import {EmbeddedProvider} from './EmbeddedContext'

interface ContentAreaProps {
    children: ReactNode
    className?: string
    'data-testid'?: string
}

export function ContentArea({children, className, 'data-testid': dataTestId}: ContentAreaProps) {
    return (
        <div className={cn('flex-1 min-w-0', className)} data-testid={dataTestId}>
            <EmbeddedProvider>{children}</EmbeddedProvider>
        </div>
    )
}
